<template>
    <div class="columns">
      <div class="column">
        <current-period />
      </div>

      <div class="column middle-column">
        <payment-method />
      </div>

      <div class="column">
        <customer-invoices />
      </div>
    </div>
</template>

<script>
import CustomerInvoices from './CustomerInvoices'
import CurrentPeriod from './CurrentPeriod'
import PaymentMethod from './PaymentMethod'

export default {
  name: 'CompanyBillingInfo',

  components: {
    CustomerInvoices,
    CurrentPeriod,
    PaymentMethod
  }
}
</script>

<style scoped>
.middle-column {
  border-right: 1px solid blue;
  border-left: 1px solid blue;
}
</style>
